import Component from "../abstracts/Component";
import {doAjax} from "../utils/ajaxUtil";
import WishlistLogic from "../logics/WishlistLogic";
import TrackingComponent from "../components/TrackingComponent";
import {Select2Init} from "../utils/Select2Init";

export default class WishlistComponent extends Component {
  get SELECTORS() {
    return {
      wishBtn: "[data-js-wishlist]",
      wishSizeSelectors: "[data-sizes-select] select",
      wishlistEmptySection: "[data-wishlist-empty]",
      wishlistFullSection: "[data-wishlist-full]"
    };
  }

  get CLASSES() {
    return {
      addBtnClass: "js-add-to-wish",
      addedBtnClass: "js-added-wish",
      removeBtnClass: "js-remove-from-wish",
      error: "error",
    };
  }

  constructor(el) {
    super(el);
    // all wishlist button of
    this.wishBtn = this.$component.querySelectorAll(this.SELECTORS.wishBtn);
    this.trackingComponent = new TrackingComponent();
    this.wishlistLogic = new WishlistLogic();
    this.wishSizeSelectors = document.querySelectorAll(this.SELECTORS.wishSizeSelectors);
    this.wishlistEmptySection = this.$component.querySelector(this.SELECTORS.wishlistEmptySection);
    this.wishlistFullSection = this.$component.querySelector(this.SELECTORS.wishlistFullSection);
  }

  // select change reset
  listenSelectWishSize() {
    let ctx = this;
    if (this.wishSizeSelectors != null) {
      this.wishSizeSelectors.forEach((select) => {
        select.addEventListener("change", (elem) => {
          // no default action
          elem.stopPropagation();
          // reset error
          if (select.parentElement.classList.contains(ctx.CLASSES.error)) {
            select.parentElement.classList.remove(ctx.CLASSES.error);
          }
          //TODO-not-working-properly
          /*if ( select.selectedOptions.length > 0 && typeof select.selectedOptions[0] !== 'undefined' ) {
            if (!select.selectedOptions[0].classList.contains('unavailable')) {
              // adding
              let url = select.getAttribute('data-wish-add-url');
              ctx.addToWishlist(select.selectedOptions[0],url);
            }
          }*/
        });
      });
    }
  }

  // listen to click
  listenBtnWish(btns) {
    // global
    let ctx = this;
    // if not passed
    if (typeof btns == "undefined") btns = this.wishBtn;
    //
    if (btns != null) {
      btns.forEach((btn) => {
        btn.addEventListener("click", (elem) => {
          // no default action
          elem.stopPropagation();
          // in base of button class
          const isAdding = btn.dataset.jsWishlist === 'empty';
          if (isAdding) {
            // adding
            let url = btn.getAttribute("data-add-url");
            ctx.addToWishlist(btn, url);
          } else {
            // removing
            let url = btn.getAttribute("data-remove-url");
            ctx.removeToWishlist(btn, url);
          }
        });
      });
    }
  }

  //
  addToWishlist(elem, url) {
    // vars
    let ctx = this;
    let code = elem.dataset.code;
    // ajax
    doAjax({
      url: url + code,
      dataType: "html",
      success: function (resp) {
        ctx.log("added to wishlist", code);
        // n of items on wishlist
        let qty = resp;
        // event
        const addedMessage = elem.dataset.addedMessage;
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtowish, { elem: elem, qty: qty, msg: addedMessage });
        ctx.trackingComponent.trackAction("wishlistAdd", elem.dataset, elem);
        elem.dataset.jsWishlist = 'full';
      },
      error: function (xhr) {
        console.log("error in add to wishlist");
      },
    });
  }

  //
  removeToWishlist(elem, url) {
    // vars
    let ctx = this;
    const code = elem.dataset.code;
    // ajax
    doAjax({
      url: url + code,
      dataType: "json",
      type: "POST",
      success: function (resp) {
        // n of items on wishlist
        let qty = resp.count;
        // launch event
        const removedMessage = elem.dataset.removedMessage;
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedfromwish, { elem: elem, qty: qty, msg: removedMessage });
        elem.dataset.jsWishlist = 'empty';
      },
      error: function (xhr) {
        console.log(xhr);
      },
    });
  }

  // wishlist check
  wishlistCheckAjax(code) {
    return new Promise((resolve, reject) => {
      let data = {};
      data[code] = code;
      //
      let contextPath = document.getElementsByTagName("HTML")[0].getAttribute("data-context");
      $.ajax({
        url: contextPath + "/action/ajax/wishlist-check-product",
        data: {
          code: code,
        },
        success: function (result) {
          // resolve
          resolve(result);
        },
      });
    });
  }

  updateWishButton(btn, disable) {
    // check
    if (btn == null) return false;
    //
    if (disable === true) {
      // disable button
      btn.classList.remove(this.CLASSES.addBtnClass);
      btn.classList.add(this.CLASSES.addedBtnClass);
      btn.classList.add(this.CLASSES.removeBtnClass);
    } else {
      // enable button
      btn.classList.add(this.CLASSES.addBtnClass);
      btn.classList.remove(this.CLASSES.addedBtnClass);
      btn.classList.remove(this.CLASSES.removeBtnClass);
    }
  }

  bindEvents() {
    let ctx = this;
    // addedtowish managed by wishlistLogic

    // event on remove from wish
    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, ({event, payload}) => {
      // btn
      let btn = payload.elem;
      let qty = payload.qty;
      if(qty > 0){
        if(ctx.wishlistFullSection && ctx.wishlistFullSection.classList.contains("hidden")){
          ctx.wishlistFullSection.classList.remove("hidden");
          ctx.wishlistEmptySection.classList.add("hidden");
        }
      } else {
        if(ctx.wishlistEmptySection && ctx.wishlistEmptySection.classList.contains("hidden")){
          ctx.wishlistEmptySection.classList.remove("hidden");
          ctx.wishlistFullSection.classList.add("hidden");
        }
      }
      // if it's the delete button on wishlist page
      if (btn.dataset.deleteButton) {
        let code = btn.dataset.code;
        let prodCard = ctx.$component.querySelector('[data-card-code="' + code + '"]');
        if (prodCard != null) prodCard.remove();
      } else {
        // managed by WishlistLogic
      }
    });

    // event on select size - i want to wishlist the product with the size
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({event, payload}) => {
      // search the btn with the base product code
      let btnWish = document.querySelector('[data-wishlist-code="' + payload.box.dataset.productCode + '"]');
      // put in the button the size code
      btnWish.dataset.code = payload.button.dataset.productCode;
      // check size on size select
      // go promise
      ctx.wishlistCheckAjax(payload.button.dataset.productCode).then((result) => {
        // result
        if (result === "true") {
          // if is in WL i disanble the button
          ctx.updateWishButton(btnWish, true);
        } else {
          // if not i enable it
          ctx.updateWishButton(btnWish, false);
        }
      });
    });

    // event simplebar loader
    this.$on(this.$customEvents.SIMPLEBAR_EVENTS.loaded, ({event, payload}) => {
      // let's search the wish buttons
      let btns = payload.elem.querySelectorAll(ctx.SELECTORS.wishBtn);
      if (btns != null) {
        ctx.listenBtnWish(btns);
      }
    });

    // Size not selected event
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, (e) => {
      // find error box
      let sizeBox = document.querySelector("[data-sizes-code=prod_" + e.payload.getAttribute("data-code") + "]");
      if (sizeBox != null) {
        sizeBox.classList.add(ctx.CLASSES.error);
      }
    });

    // listing page when launched the filters i need to rebind all buttons
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      // let's search the wish buttons
      let btns = document.querySelectorAll(ctx.SELECTORS.wishBtn);
      if (btns != null) {
        ctx.listenBtnWish(btns);
      }
    });

    // listing when fired pagination and infinite scroll
    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.loaded, ({event, payload}) => {
      // let's search the wish buttons
      const { newProducts } = payload;
      const btns = [...newProducts].map(productCard => productCard.querySelector(ctx.SELECTORS.wishBtn));
      if (btns != null) {
        ctx.listenBtnWish(btns);
      }
    });
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
    // add btn
    this.listenBtnWish();
    // select reset
    this.listenSelectWishSize();
    // wishlist logic
    this.wishlistLogic.render();
    //init select2
    Select2Init();
  }
}
